export default "__VITE_ASSET__BktAl4k1__"